import { render, staticRenderFns } from "./TicketPriceBreakdown.vue?vue&type=template&id=6bcffb72&"
import script from "./TicketPriceBreakdown.vue?vue&type=script&lang=js&"
export * from "./TicketPriceBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports